var CheckoutPlus = (function(){
  
  var _cart = {
    items: [],
    token: null
  };
  
  var init = function(){
    getCartData(function(cart){
      _cart.token = cart.token;
      for(var i = 0; i < cart.items.length; i++){
        _cart.items.push(only(cart.items[i], ["product_id", "variant_id", "quantity", "price", "image", "title"]));
      };
    });
    observers();
  };
  
  var observers = function(){
    var cart_btn = document.getElementsByName("checkout")[0];
    if(cart_btn){
      cart_btn.addEventListener('click', function(e){
        e.preventDefault();
        createCheckout();
      });
    };
  };
  
  var getCartData = function(callback){
    httpReq({
      endpoint: "/cart.json",
      method: "GET",
      done: function(r){
        callback(r);
      }
    });
  };
  
  var createCheckout = function(){
    httpReq({
      endpoint: "https://2aff7f44.ngrok.io/checkout/new",
      method: "POST",
      data: objToQueryParam(_cart),
      done: function(r){
        createCookie("cp_checkout_token", r.token);
        window.location = r.url;
      },
      error: function(r){ console.log(r); }
    });
  };
  
  var httpReq = function(options) {
    var xhr = new XMLHttpRequest();
    xhr.open(options.method, encodeURI(options.endpoint), true);
    if (options.method == "POST") {
      xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    };
    xhr.onload = function() {
      if (xhr.status === 200) {
        options.done(JSON.parse(xhr.responseText));
      } else {
        options.error(JSON.parse(xhr.responseText));
      };
    };
    xhr.send(options.data);
  };
  
  var only = function(obj, keys) {
    return Object.keys(obj).reduce((result, key) => {
      if(keys.includes(key))
         result[key] = obj[key];
      return result;
    }, {});
  };
  
  var objToQueryParam = function(obj){
    var result = [];
    for(var k in obj){
      var key_string = k;
      if(typeof obj[k] === "object"){
        for(var i = 0; i < obj[k].length; i++){
          for(var z in obj[k][i]){
            result.push(""+ key_string +"["+ i +"]["+ z +"]="+ obj[k][i][z] +"");
          };
        };
      }else{
        result.push(""+ key_string +"="+ obj[k] +"");
      };
    };
    return result.join("&");
  };
  
  function createCookie(name, value, days) {
    var expires;
    if(days){
      var date = new Date();
      date.setTime(date.getTime()+(days*24*60*60*1000));
      expires = "; expires="+date.toGMTString();
    }else{
      expires = "";
    };
    document.cookie = name+"="+value+expires+"; path=/";
  }

  function readCookie(name){
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++){
      var c = ca[i];
      while(c.charAt(0) === ' '){
        c = c.substring(1,c.length);
      };
      if(c.indexOf(nameEQ) === 0){
        return c.substring(nameEQ.length,c.length);
      };
    };
    return null;
  };

  function eraseCookie(name){
    createCookie(name,"",-1);
  };

  return {
    init: init,
    cart: function(){
      return _cart;
    }
  };
  
}());

//CheckoutPlus.init();